export enum OrderByEnum {
  CREATION_UP,
  CREATION_DOWN,
  MAKE_MODEL,
  PRICE_UP,
  PRICE_DOWN,
}
